import { Action, ActionReducer, createReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

export interface HeaderState {}

export const initialHeaderState: HeaderState = {};

const reducer = createReducer(initialHeaderState);

export function headerReducer(state: HeaderState | undefined, action: Action) {
  return reducer(state, action);
}

export function headerStorageSync(reducer: ActionReducer<HeaderState>): ActionReducer<HeaderState> {
  return localStorageSync({
    keys: [{ header: ['layout'] }],
    rehydrate: true,
    storageKeySerializer: key => 'header_' + key,
  })(reducer);
}
